export const SPOTLIGHT_SEARCH_LIMIT_PER_ENTITY = 12;
